import c from "class-c";

import CommunityPost from "@repo/kikoff-models/community/CommunityPost";
import Duration from "@repo/utils/Duration";
declare namespace PostTimer {
  type Props = {
    class?: string;
    post: CommunityPost;
  };
}

function PostTimer({ post, class: className }: D<PostTimer.Props>) {
  const timeAgo = Duration.format.maxUnits(1).default("now")(
    Date.now() - post.postedAt.getTime(),
    "narrow"
  );

  return (
    <span class={c`color:moderate-weak ${className}`}>
      {timeAgo} {timeAgo !== "now" && "ago"}
    </span>
  );
}

export default PostTimer;
